import { render, staticRenderFns } from "./VInventoryItemFiles.vue?vue&type=template&id=4cf0ad4b"
import script from "./VInventoryItemFiles.vue?vue&type=script&lang=js"
export * from "./VInventoryItemFiles.vue?vue&type=script&lang=js"
import style0 from "./VInventoryItemFiles.vue?vue&type=style&index=0&id=4cf0ad4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports